import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var GoogleDriveSvg = function GoogleDriveSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.224 4.916H10.793L2.667 19.783l5.246 7.8h16.811l4.61-7.831zM4.718 19.689l7.123-13.03h.143l3.254 5.528-6.936 12.83zm5.136 6.15h13.86l3.079-5.231H12.682zm3.77-6.975h5.545l-2.89-4.91zm7.581 0L14.021 6.66h6.155l6.671 12.205z",
    clipRule: "evenodd"
  }));
};
export var GoogleDrive = function GoogleDrive(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: GoogleDriveSvg
  }));
};